export const CHECKOUT_PAGE_REQUEST = "checkoutReducer/CHECKOUT_PAGE_REQUEST";
export const CHECKOUT_PAGE_SUCCESS = "checkoutReducer/CHECKOUT_PAGE_SUCCESS";
export const CHECKOUT_PAGE_FAILED = "checkoutReducer/CHECKOUT_PAGE_FAILED";
